/**
 * PlacementStatusBadge - the Placement status chip (§10.1). One Badge tone per status; the label
 * is the shared PLACEMENT_STATUS_LABELS entry (single source of truth).
 */

import { Badge } from '../../components/ui/Badge';
import type { BadgeVariant } from '../../components/ui/Badge';
import { PLACEMENT_STATUS_LABELS } from '@brokly/shared';
import type { PlacementStatus } from '@brokly/shared';

const STATUS_TONE: Record<PlacementStatus, BadgeVariant> = {
  entwurf: 'neutral',
  risikoprofil_erfasst: 'info',
  vorgaben_erfasst: 'info',
  ausgeschrieben: 'info',
  verglichen: 'warning',
  empfohlen: 'warning',
  entschieden: 'warning',
  abgeschlossen: 'success',
  abgebrochen: 'danger',
};

export function PlacementStatusBadge({ status }: { status: PlacementStatus }) {
  return (
    <Badge variant={STATUS_TONE[status]} data-testid="placement-status-badge">
      {PLACEMENT_STATUS_LABELS[status]}
    </Badge>
  );
}
